<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item>
                <el-button
                    type="success"
                    size="mini"
                    @click="antiInternalBidding"
                    :disabled="disabled"
                    >防内部竞价</el-button
                >
            </el-form-item>
            <el-form-item
                label=""
                class="query-form-item"
                style="float:right;margin-right:6px;"
            >
                <el-button size="mini" @click="onDownloadList"
                    >下载列表</el-button
                >
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            @sort-change="handleSortChange"
            style="width: 100%;"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="关联ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="项目组" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shop_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="开始日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="结束日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.end_date || "-" }}</div>
                </template>
            </el-table-column>
        </el-table>
        <DownloadList
            :activeName="activeName"
            :visible="ctrl.DownloadListDialogVisible"
            :title="'下载列表'"
            @close-callback="closeCllback"
        >
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    label="防内部竞价"
                    name="antiInternal"
                    style="padding: 0 25px;"
                >
                    <DownloadView
                        ref="antiInternal"
                        :task_type="1"
                    ></DownloadView>
                </el-tab-pane>
                <el-tab-pane
                    label="品牌竞价"
                    name="brand"
                    style="padding: 0 25px;"
                >
                    <DownloadView ref="brand" :task_type="2"></DownloadView>
                </el-tab-pane>
            </el-tabs>
        </DownloadList>
    </div>
</template>

<script>
import * as api from "@/api/statistics/statistics";
import Upload from "../upload";
import DownloadList from "../downloadList";
import DownloadView from "../downloadView";
import AddPpc from "../addPpc";
import { binary_download } from "../../../utils/method";
export default {
    name: "preventBid",
    components: { Upload, DownloadList, DownloadView, AddPpc },
    data() {
        return {
            tableHeight: null,
            ctrl: {
                DownloadListDialogVisible: false,
                addPpcDialogVisible: false,
                uploadDialogVisible: false
            },
            query: {
                page: 1,
                limit: 20,
                total: 0,
                project_name: "",
                state: "",
                order: "",
                desc: ""
            },
            record_id: 0,
            activeName: "antiInternal",
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            relevance_id_list: []
        };
    },
    created() {
        this.query.asin = this.$route.query.asin;
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
        this.getList();
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    methods: {
        handleSelectionChange(val) {
            this.relevance_id_list = val.map(item => {
                return item.id;
            });
        },

        getList() {
            this.loading = true;
            api.prevent_internal_competition_logic_show(this.query)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.relevance_detail;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        antiInternalBidding() {
            this.disabled = true;
            api.prevent_internal_competition_logic_analysis_by_relevance({
                asin: this.query.asin,
                relevance_id_list: this.relevance_id_list
            })
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message:
                                "正在分析数据，后续可通过下载列表进行下载文件！"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        brandBidding(data) {
            this.listDisabled = true;
            api.check_brand_ppc({
                asin: this.query.asin,
                record_id: data.id
            })
                .then(res => {
                    this.listDisabled = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message:
                                "正在分析数据，后续可通过下载列表进行下载文件！"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.listDisabled = false;
                });
        },
        handleSortChange(val) {
            if (val.order == "ascending") {
                this.query.desc = "desc";
                this.query.order = val.prop;
            } else if (val.order == "descending") {
                this.query.desc = "asc";
                this.query.order = val.prop;
            }
            this.getList();
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList();
            });
        },
        //重置
        onReset() {
            this.query.project_name = "";
            this.query.state = "";
            this.query.order = "";
            this.query.desc = "";
            this.query.page = 1;
            this.getList();
        },
        //查询
        onSubmit() {
            this.getList();
        },
        change() {
            this.getList();
        },
        clearValue() {
            this.query.state = "";
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true;
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true;
            this.$nextTick(() => {
                this.$refs[this.activeName].getList();
            });
        },
        downFile(row) {
            if (!row.import_path) {
                return this.$message({
                    type: "error",
                    message: "无法下载！"
                });
            }
            binary_download(
                "/apis/v1/common_file_export_by_path",
                "post",
                {},
                {
                    file_path: row.import_path
                },
                "application/vnd.ms-excel",
                row.filename
            );
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id;
            this.ctrl.addPpcDialogVisible = true;
        },
        //删除
        delete_file(data) {
            this.$confirm(`确定要删除这条记录吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.listing_ad_data_delete({
                        id: data.id
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(res => {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        });
                })
                .catch(() => {});
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.uploadDialogVisible = false;
            this.ctrl.addPpcDialogVisible = false;
            this.ctrl.DownloadListDialogVisible = false;
            isshow == true && this.getList();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
